import { apiUrl } from "../taskpane";

export async function translateStrings(targetLanguage, strings) {
  const uniqueStrings = Array.from(
    new Set((Array.isArray(strings) ? strings : []).map((item) => String(item || "").trim()).filter(Boolean))
  );

  if (!uniqueStrings.length) {
    return {};
  }

  const response = await fetch(apiUrl("translate"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      target_language: targetLanguage,
      strings: uniqueStrings,
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.detail || "Translation request failed");
  }

  return data?.translations || {};
}